module.exports = __webpack_public_path__ + "img/pic_9.782ea291.jpg";